import React from 'react'
import { Table } from '@chakra-ui/react'

export const BookPurchaseHistoryListTable = ({ histories }) => {
  const cellStyles = {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '13px',
    lineHeight: '20px',
  }
  return (
    <Table.Root variant="simple">
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeader {...cellStyles}>購入日</Table.ColumnHeader>
          <Table.ColumnHeader {...cellStyles}>作品名</Table.ColumnHeader>
          <Table.ColumnHeader {...cellStyles}>価格(税込)</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {histories.map((history, index) => (
          <Table.Row key={`book-purchase-history-${index}`}>
            <Table.Cell {...cellStyles}>{history.created_at.split('T')[0].split('-').slice(1).join('/')}</Table.Cell>
            <Table.Cell {...cellStyles}>{history.content_name}</Table.Cell>
            <Table.Cell {...cellStyles}>{history.price.toLocaleString()}円</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  )
}
